export enum SurveyType {
  NPS = 'NPS',
  PULSE = 'PULSE',
}
